// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-rVA","controls":"styles_controls__1kDpq","charLimit":"styles_charLimit__2NP0Z","input":"styles_input__yun6c","send":"styles_send__1Suxv"};